import React, { memo, useMemo } from 'react';

import { TablePagination } from '@mui/material';
import SimpleTable, { simpleTablePropTypes } from '@sharedCR/common/SimpleTable';
import PropTypes from 'prop-types';

import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from './TableCDS.constants';
import { getCustomStyles } from './TableCDS.styles';

const TableCDS = ({
  customStyles,
  pendingChangesTextSelector = 'p',
  isLoading,
  onRowClick,
  getRowProps,
  isDroppable,
  customSearchControls,
  paginationProps,
  ...props
}) => {
  const mergedCustomStyles = useMemo(() => {
    return getCustomStyles({
      customStyles,
      pendingChangesTextSelector,
      isLoading,
      onRowClick,
      getRowProps,
      isDroppable,
    });
  }, [customStyles, pendingChangesTextSelector, isLoading, onRowClick, getRowProps, isDroppable]);

  return (
    <>
      <SimpleTable
        {...props}
        customSearchControls={customSearchControls}
        customStyles={mergedCustomStyles}
        getRowProps={getRowProps}
        isDroppable={isDroppable}
        isLoading={isLoading}
        pendingChangesTextSelector={pendingChangesTextSelector}
        onRowClick={onRowClick}
      />
      {paginationProps && !!paginationProps.count && (
        <TablePagination
          component="div"
          count={paginationProps.count}
          page={paginationProps.page}
          rowsPerPage={paginationProps.rowsPerPage}
          rowsPerPageOptions={paginationProps.rowsPerPageOptions || DEFAULT_ROWS_PER_PAGE_OPTIONS}
          onPageChange={paginationProps.onPageChange}
          onRowsPerPageChange={paginationProps.onRowsPerPageChange}
        />
      )}
    </>
  );
};

TableCDS.propTypes = {
  ...simpleTablePropTypes,
  paginationProps: PropTypes.shape({
    count: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    rowsPerPageOptions: PropTypes.array,
    onRowsPerPageChange: PropTypes.func,
  }),
};

export default memo(TableCDS);
